import LoadingSpinner from '@/shared/components/LoadingSpinner/LoadingSpinner';
import SettingsViewWrapper from '@/shared/components/SettingsViewWrapper/SettingsViewWrapper';
import { useUser } from '@/shared/hooks/user';
import { Trans, useTranslation, withTranslation } from 'react-i18next';
import { IonButton, IonRouterLink, IonText } from '@ionic/react';
import contactInformation from '@/shared/config/contactInformation';
import styles from './UserChange.module.css';

const UserChange: React.FC = () => {
  const { t } = useTranslation();
  const user = useUser();

  return (
    <SettingsViewWrapper name="user-change-page" title={t('user_change.title')}>
      {user ? (
        <div className={styles.container}>
          <IonText>{t('user_change.description')}</IonText>
          <div className={styles.userChangeContainer}>
            <IonText>{t('user_change.text_field.label')}</IonText>
            <div className={styles.buttonWrapper}>
              <IonButton
                size="small"
                href={'/documents/Annex_2-1_Registration&change_of_contact_persons&users.pdf'}
                download={'Annex_2-1_Registration&change_of_contact_persons&users.pdf'}
              >
                {t('user_change.text_field.download')}
              </IonButton>
            </div>
          </div>
          <IonText>
            <Trans
              i18nKey="user_change.contact_info"
              values={{ emailAddress: contactInformation.sales.title }}
              components={{ email: <IonRouterLink href={contactInformation.sales.url} target="_blank" /> }}
            />
          </IonText>
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </SettingsViewWrapper>
  );
};

export default withTranslation()(UserChange);
